import { Component, OnInit } from '@angular/core';
import { ICellRendererParams, IAfterGuiAttachedParams } from 'ag-grid-community';
import { AgRendererComponent } from 'ag-grid-angular';

@Component({
  selector: 'pps-operation-access-setting-action',
  template: `
  <input type="checkbox" name="hasAccess" [(ngModel)]="hasAccess" (change)="onChange()"/>
  `,
  styles: [
  ],
})
export class OperationAccessSettingActionComponent implements AgRendererComponent {
  private params: any;
  hasAccess: boolean;

  constructor() { }

  refresh(params: any): boolean {
    return true;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.hasAccess = this.params.data.hasAccess;
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
    throw new Error("Method not implemented.");
  }

  onChange(){
    console.log(this.params);
    this.params.data.hasAccess = this.hasAccess;
    this.params.context.componentParent.updateRoleOperationSetting(this.params.data);
    this.params.context.componentParent.roleOperationGridApi.redrawRows({rowNodes: [this.params.node]});
  }
}
